import 'bootstrap-icons/font/bootstrap-icons.css';
import _ from 'underscore';

import ApplicationLauncher from '../../../shared/services/applicationLauncher.js';
import { initKeycloak } from '../../../shared/services/keycloakService.js';
import dayjs from '../../../shared/services/dayjs.js';
import { schichtenService } from './services/SchichtenService.js';
import { stammdatenService } from './services/StammdatenService.js';
import { datumService } from './services/DatumService.js';
import { zeigeKleineNachricht } from './systemNachricht.js';
import { toolbarFun } from './toolbar.js';
import { findeMitarbeiter, findePosten, findeQualifikation } from './util.js';
import { entferneSchichtElement, ladeUrlaubsantraegeMA, zeigeDienstplan, zeigeNeueSchicht, filterZuruecksetzen, passeVorlagenBereichAn } from './dienstplan.js';
import { bestaetige } from './dialogs/bestaetigung.js';
import { zeigeMitarbeiteransicht } from './views/mitarbeiteransichtView.js';
import { zeigeBedarfsplaner } from './views/bedarfsplanerView.js';
import { viewSwitcherFun } from './views/viewSwitcher.js';
import { toggleFilterPanel, toggleFilterSektion } from './components/filterPanel.js';
import { erstelleSchichtInputFeld } from './schichtEditor.js';
import {
	entferneZeitblockZeile,
	neuerZeitblockInput,
	zeitDifferenzHTML,
	} from './zeitblock.js';
import SystemDialogService from '../../../shared/services/systemDialogService.js';
import { Egfz } from '../../../shared/services/Egfz.js';

document.addEventListener('DOMContentLoaded', async () => {
	await initKeycloak();
});

// Zuletzt gewählte Betriebsstätte (siehe fuelleBetriebSelect/wechsleBetriebsstaette)
const BETRIEBSSTAETTE_STORAGE_KEY = 'dienstplan.betriebsstaette';

// State für das Schicht-Kopieren via Markieren + Klick auf Zielzelle.
let kopierQuelleSchichtID = null;
let kopierInProgress = false;

// Globale Funktionen, die mit onclick, onchange, etc. aufgerufen werden können
window.myServices = window.myServices || {};
window.fun = window.fun || {};
window.fun.schichtEditieren = schichtEditieren;
window.fun.schichtAdden = schichtAdden;
window.fun.schichtEntfernen = schichtEntfernen;
window.fun.markiereKopierQuelle = markiereKopierQuelle;
window.fun.clearKopierQuelle = () => clearKopierQuelle();
window.fun.istKopierQuelleSchicht = (schichtID) => kopierQuelleSchichtID && kopierQuelleSchichtID === schichtID;
window.fun.schichtNotizBearbeiten = schichtNotizBearbeiten;
window.fun.zeitDifferenzHTML = zeitDifferenzHTML;
window.fun.entferneZeitblockZeile = entferneZeitblockZeile;
window.fun.neuerZeitblockInput = neuerZeitblockInput;
window.fun.wechsleBetriebsstaette = wechsleBetriebsstaette;
window.fun.confirmQualiSelectDialog = confirmQualiSelectDialog;
window.fun.togglePosten = togglePosten;
window.fun.zeigeNachricht = zeigeKleineNachricht;
window.fun.toggleFilterPanel = toggleFilterPanel;
window.fun.toggleFilterSektion = toggleFilterSektion;
window.fun.filterZuruecksetzen = () => filterZuruecksetzen(() => viewSwitcherFun.renderAktiveView());
window.tb = toolbarFun;
window.vs = viewSwitcherFun;
// Wenn der User außerhalb des Modals clickt, schließe es
window.onclick = (event) => {
	if (event.target.id === 'my-modal') {
		closeModal();
	}
};

// Lade den Dienstplan initial für die aktuelle KW. Ladeanzeige übernimmt zeigeDienstplan() selbst
// (nur über dem Grid, siehe dp-grid-loader in dienstplan.css) — kein globales toggleLoader() mehr,
// das würde zusätzlich die ganze Seite abdunkeln.
ApplicationLauncher.instance.pushEventListener(async () => {
	const clock = document.getElementById('neolohn-clock');
	setInterval(() => { clock.innerHTML =
		`${dayjs().tz().format('HH:mm:ss')}<small>${dayjs().tz().format('DD.MM.YYYY')}</small>`;
	}, 500);
	zeigeAvatar();
	await initDienstplan();
	// Erst nach dem initialen Wochenplan-Boot-Render verdrahten, siehe views/viewSwitcher.js:init.
	viewSwitcherFun.init();
	SystemDialogService.instance.onAbort(() => zeigeKleineNachricht('Eingabe abgebrochen!', 0));
});

/**
 * Füllt den Avatar in der Appbar mit den Initialen des angemeldeten Users (aus dem Keycloak-Token,
 * siehe shared/services/keycloakService.js:window.myVars.Username).
 */
function zeigeAvatar() {
	const avatar = document.getElementById('avatar');
	if (!avatar || !window.myVars?.Username) return;
	const initialen = window.myVars.Username
		.split(' ')
		.filter(Boolean)
		.map((teil) => teil[0])
		.join('')
		.slice(0, 2)
		.toUpperCase();
	avatar.innerText = initialen;
	avatar.title = window.myVars.Username;
}

/**
 * Initialisiert den Dienstplan mit aktuellen Daten
 */
async function initDienstplan() {
	const unternehmen = await stammdatenService.getUnternehmensdaten();
	const aktiveBS = unternehmen.Betriebsstaette.filter((bs) => bs.Aktiv === true);
	// Wähle die erste Betriebsstätte im Voraus aus, falls noch keine ausgewählt wurde.
	if (aktiveBS.length <= 0) {
		zeigeKleineNachricht('Es wurden noch keine aktiven Betriebsstätten hinterlegt!', 0);
		return;
	}
	await fuelleBetriebSelect();
	// Wird per URL eine andere Ansicht angefordert (siehe views/viewSwitcher.js:init), nur die Toolbar
	// befüllen — sonst würde der unsichtbare Wochenplan komplett geladen und gerendert.
	const angeforderteView = new URLSearchParams(window.location.search).get('view');
	await zeigeDienstplan(false, false, false, false, ['mitarbeiter', 'bedarf'].includes(angeforderteView));
}

async function wechsleBetriebsstaette(thisElement) {
	const bs = thisElement.options[thisElement.selectedIndex];
	stammdatenService.aktuelleBetriebsstaette = bs.value;
	try {
		localStorage.setItem(BETRIEBSSTAETTE_STORAGE_KEY, bs.value);
	} catch {
		// localStorage nicht verfügbar — Auswahl gilt dann nur bis zum Neuladen
	}
	// Diensplan laden mit reset — die Chrome (#bereich-select/Vorlagen-Toolbar-Select) wird ausschließlich
	// hier über den Wochenplan neu befüllt, siehe views/viewSwitcher.js. Ist die Mitarbeiteransicht
	// gerade aktiv, wird sie danach zusätzlich neu gerendert, damit beide Ansichten synchron bleiben.
	// In einer anderen Ansicht nur die Toolbar über den Wochenplan befüllen, das unsichtbare Raster nicht rendern.
	const initialised = false;
	const nurToolbar = viewSwitcherFun.getAktiveView() !== 'wochenplan';
	await zeigeDienstplan(initialised, true, false, false, nurToolbar);
	if (viewSwitcherFun.getAktiveView() === 'mitarbeiter') {
		await zeigeMitarbeiteransicht(true);
	} else if (viewSwitcherFun.getAktiveView() === 'bedarf') {
		await zeigeBedarfsplaner(true);
	}
}

// Ladet alle Betriebstätten in die select-betriebsstaette Auswahl
async function fuelleBetriebSelect() {
	const select = document.getElementById('select-betriebsstaette');
	// Reset wenn es schonmal befüllt wurde
	select.innerHTML = '';
	const unternehmen = await stammdatenService.getUnternehmensdaten();
	const aktiveBS = unternehmen.Betriebsstaette.filter((bs) => bs.Aktiv === true);
	// Die zuletzt gewählte Betriebsstätte, sofern noch aktiv, sonst die erste.
	let gespeichert = null;
	try {
		gespeichert = localStorage.getItem(BETRIEBSSTAETTE_STORAGE_KEY);
	} catch {
		// localStorage nicht verfügbar
	}
	stammdatenService.aktuelleBetriebsstaette = aktiveBS.some((bs) => bs._id === gespeichert) ? gespeichert : aktiveBS[0]._id;
	aktiveBS.forEach((bs) => {
		const option = document.createElement('option');
		option.innerText = `${unternehmen.UnternehmenName} | ${bs.BetriebsstaetteName}`;
		option.value = bs._id;
		select.appendChild(option);
	});
	// Select muss die tatsächlich geladene Betriebsstätte zeigen (toolbar.js liest select.value)
	select.value = stammdatenService.aktuelleBetriebsstaette;
}

/**
 * Löscht eine Schicht aus der Datenbank, zeigt vorher eine Warnung
 * @param {string} schichtID
 * @param {Event} event
 * @param {string} gridId
 */
async function schichtEntfernen(schichtID, event, gridId) {
	event.stopPropagation();
	const schicht = await schichtenService.holeSchichtObjekt(schichtID);
	if (schicht.Zeitbloecke[0].EgfzID === Egfz.Urlaub) {
		ladeUrlaubsantraegeMA(schicht.MitarbeiterID);
		return;
	}
	const mitarbeiter = await stammdatenService.getMitarbeiter();
	const mitarbeiterPersonalien = findeMitarbeiter(mitarbeiter, schicht.MitarbeiterID).Personalien;
	const nachricht = `Wollen Sie wirklich diese Schicht löschen?\n${`${mitarbeiterPersonalien.Vorname} ${mitarbeiterPersonalien.Nachname}`}\n${schicht.Titel}\n${dayjs(schicht.Datum).format('DD.MM.YYYY')}`;
	document.getElementById('schicht-delete-dialog').querySelector('.nachricht-info').innerText = nachricht;
	const userInput = await SystemDialogService.instance.displayAsync('schicht-delete-dialog');
	if (userInput.success) {
		const result = await schichtenService.entferneSchichtObjekt(schichtID);
		if (result) {
			await entferneSchichtElement(result, gridId);
			closeModal();
		} else {
			await SystemDialogService.instance.displayAsync('fehler-schicht-delete-dialog');
		}
	}
}

/**
 * Öffnet ein Modal, um die Daten anzuzeigen und zu editieren
 * @param {string} schichtID
 * @param {string} gridId zeigt auf das Feld im Grid, auf das geklickt wurde.
 */
async function schichtEditieren(schichtID, event, gridId) {
	event.stopPropagation();
	// Ctrl/Cmd+Klick auf eine reguläre Dienstplan Schicht markiert sie als Kopierquelle.
	const schichtElement = event.target.closest('.schicht-div');
	const istKopierfaehig = schichtElement
		&& !schichtElement.classList.contains('egfz-schicht')
		&& !schichtElement.classList.contains('schicht-panel');
	if ((event.ctrlKey || event.metaKey) && istKopierfaehig) {
		markiereKopierQuelle(schichtID, schichtElement);
		return;
	}
	// Klick auf eine Schicht ohne Modifier hebt eine evtl. aktive Kopierquelle auf.
	clearKopierQuelle();
	const schicht = await schichtenService.holeSchichtObjekt(schichtID);
	erstelleSchichtInputFeld(schicht, 1, gridId);
}

/**
 * Öffnet ein Modal, um die Daten anzuzeigen und zu editieren
 * @param {string} schichtID
 * @param {string} gridId zeigt auf das Feld im Grid, auf das geklickt wurde.
 */
async function schichtNotizBearbeiten(schichtID, event, gridId) {
	event.stopPropagation();
	// check old notiz
	const schicht = await schichtenService.holeSchichtObjekt(schichtID);
	const notizInput = document.getElementById('schicht-notiz-dialog-input');
	notizInput.value = schicht.SchichtNotiz || '';
	const result = await SystemDialogService.instance.displayAsync('schicht-notiz-dialog');
	if (result.success) {
		const notiz = result.data.Notiz;
		const updatedSchicht = await schichtenService.updateSchichtNotiz(schichtID, notiz);
		if (updatedSchicht) {
			await zeigeNeueSchicht(updatedSchicht, gridId);
			notizInput.value = '';
		}
	}
}

/**
 * Öffnet ein Modal für die Schichterstellung
 * @param {string} gridId zeigt auf das Feld im Grid, auf das geklickt wurde.
 */
async function schichtAdden(gridId) {
	// Eine markierte Kopierquelle hat Vorrang vor einer ausgewählten Schichtvorlage.
	if (kopierQuelleSchichtID) {
		await kopiereSchichtInZelle(gridId);
		return;
	}
	// Initiales Schichtobjekt erstellen mit Datum und MitarbeiterID
	const heutigerWochentag = parseInt(gridId.split(':')[0], 10);
	const neuesDatum = datumService.laufendesDatum.add(heutigerWochentag - 1, 'days');
	const object = {
		MitarbeiterID: gridId.split(':')[2],
		Datum: neuesDatum.format('YYYY-MM-DD'),
		PostenID: gridId.split(':')[1],
		Zeitbloecke: [] // notwendig für die Blockeingabe
	};
	// Nur direkt (ohne Editor) aus Schichtvorlage erstellen, falls eine ausgewählt ist UND die Zelle einen
	// festen Posten hat. Eine Zelle aus der Mitarbeiteransicht (object.PostenID === '', siehe
	// addGridRow-Sentinel dort) hat keinen festen Posten — dort öffnet sich stattdessen der volle Editor,
	// vorausgefüllt mit den Inhalten der gewählten Vorlage (Posten bleibt frei/vorbelegt wählbar), siehe
	// erstelleSchichtInputFeldAusVorlage.
	const schichtVorlageID = document.getElementById('vorlage-tb-select').value;
	if (schichtVorlageID !== '' && object.PostenID) {
		if (!(await passtVorlageZumPosten(schichtVorlageID, object.PostenID))) return;
		await erstelleSchichtAusVorlage(schichtVorlageID, object, gridId);
	} else if (schichtVorlageID !== '') {
		await warneWennKeinPostenImVorlagenBereich(schichtVorlageID, object.MitarbeiterID);
		await erstelleSchichtInputFeldAusVorlage(schichtVorlageID, object, gridId);
	} else {
		erstelleSchichtInputFeld(object, 0, gridId);
	}
}

/**
 * Gehört die Zielzelle (Posten) zum Bereich der Schichtvorlagen (#bereich-select)? Falls nicht, wird keine
 * Schicht angelegt, sondern angeboten, die Vorlagen auf den Bereich der Zelle umzustellen — danach wählt der
 * User dort die passende Vorlage. EGFZ-Kurzwahlen (Krank/Urlaub/...) gehören zu keinem Bereich.
 * @param {string} schichtVorlageID
 * @param {string} postenID Posten der Zielzelle
 * @returns {Promise<boolean>} true, wenn die Schicht aus der Vorlage angelegt werden darf
 */
async function passtVorlageZumPosten(schichtVorlageID, postenID) {
	const egfzID = /^\d+$/.test(String(schichtVorlageID)) ? parseInt(schichtVorlageID, 10) : null;
	if (egfzID !== null && _.values(Egfz).includes(egfzID)) return true;
	const bereichSelect = document.getElementById('bereich-select');
	const posten = findePosten(await stammdatenService.getPosten(), postenID);
	if (!posten?.BereichID || !bereichSelect || posten.BereichID === bereichSelect.value) return true;
	const vorlagenBereich = bereichSelect.selectedOptions[0]?.text ?? '';
	const zielBereich = [...bereichSelect.options].find((option) => option.value === posten.BereichID)?.text;
	if (!zielBereich) {
		zeigeKleineNachricht(`Die Schichtvorlage gehört zum Bereich „${vorlagenBereich}“ und passt nicht zum Posten „${posten.Posten}“.`, 0);
		return false;
	}
	const wechseln = await bestaetige({
		titel: 'Vorlage passt nicht zum Bereich',
		text: `Die Schichtvorlagen gehören zum Bereich „${vorlagenBereich}“, der Posten „${posten.Posten}“ zum Bereich „${zielBereich}“.\nVorlagen auf „${zielBereich}“ wechseln? Danach bitte die passende Vorlage wählen.`,
		okText: 'Vorlagen wechseln',
	});
	if (wechseln) await passeVorlagenBereichAn(posten.BereichID, true, []);
	return false;
}

/**
 * Mitarbeiteransicht (Zelle ohne festen Posten): blockiert nicht, weist aber darauf hin, wenn die Person keinen
 * Posten im Bereich der Schichtvorlagen (#bereich-select) zugeordnet hat. EGFZ-Kurzwahlen gehören zu keinem Bereich.
 * @param {string} schichtVorlageID
 * @param {string} mitarbeiterID
 */
async function warneWennKeinPostenImVorlagenBereich(schichtVorlageID, mitarbeiterID) {
	const egfzID = /^\d+$/.test(String(schichtVorlageID)) ? parseInt(schichtVorlageID, 10) : null;
	if (egfzID !== null && _.values(Egfz).includes(egfzID)) return;
	const bereichSelect = document.getElementById('bereich-select');
	if (!bereichSelect?.value) return;
	const postenListe = await stammdatenService.getPosten();
	const mitarbeiter = findeMitarbeiter(await stammdatenService.getMitarbeiter(), mitarbeiterID);
	if (!mitarbeiter.Beschaeftigung) return; // findeMitarbeiter liefert {} wenn nicht gefunden
	const hatPostenImBereich = mitarbeiter.Beschaeftigung[0].Posten
		.some((p) => findePosten(postenListe, p.PostenID)?.BereichID === bereichSelect.value);
	if (!hatPostenImBereich) {
		const name = `${mitarbeiter.Personalien?.Vorname ?? ''} ${mitarbeiter.Personalien?.Nachname ?? ''}`.trim();
		zeigeKleineNachricht(`${name} hat keinen Posten im Bereich „${bereichSelect.selectedOptions[0]?.text ?? ''}“ zugeordnet.`, 0);
	}
}

/**
 * Öffnet den vollen Schicht-Editor, vorausgefüllt mit den Inhalten der gewählten Schichtvorlage — für
 * Zellen ohne festen Posten (Mitarbeiteransicht), wo der direkte Erstellen-Kurzweg
 * (erstelleSchichtAusVorlage) mangels PostenID nicht greifen kann. Bei einer EGFZ-Kurzwahl
 * (Krank/Urlaub/...) gibt es keine "Vorlage" zum Vorausfüllen — dort bleibt der Editor leer, der
 * Posten wird frei/vorbelegt gewählt wie gewohnt.
 * @param {string} schichtVorlageID
 * @param {object} object initiales SchichtObjekt (Datum/MitarbeiterID, PostenID leer)
 * @param {string} gridId zeigt auf das Feld im Grid, auf das geklickt wurde.
 */
async function erstelleSchichtInputFeldAusVorlage(schichtVorlageID, object, gridId) {
	const egfzID = /^\d+$/.test(String(schichtVorlageID)) ? parseInt(schichtVorlageID, 10) : null;
	if (egfzID !== null && _.values(Egfz).includes(egfzID)) {
		erstelleSchichtInputFeld(object, 0, gridId);
		return;
	}
	const vorlage = await schichtenService.holeSchichtObjekt(schichtVorlageID);
	await erstelleSchichtInputFeld(object, 0, gridId, vorlage);
}

/**
 * Erstellt ein neues Schichtobjekt aus dem Template
 * @param {string} schichtVorlageID ID der Schichtvorlage
 * @param {object} schichtObjekt initiales SchichtObjekt des Mitarbeiters mit MitarbeiterID und Datum
 * @param {string} gridId zeigt auf das Feld im Grid, auf das geklickt wurde.
 */
async function erstelleSchichtAusVorlage(schichtVorlageID, schichtObjekt, gridId) {
	const qualifikationenU = await stammdatenService.getQualifikationen();
	const postenListe = await stammdatenService.getPosten();
	const posten = findePosten(postenListe, schichtObjekt.PostenID);
	schichtObjekt.Posten = posten?.Posten;
	const mitarbeiterListe = await stammdatenService.getMitarbeiter();
	const mitarbeiter = findeMitarbeiter(mitarbeiterListe, schichtObjekt.MitarbeiterID);
	schichtObjekt.BetriebsstaetteID = stammdatenService.aktuelleBetriebsstaette;

	const aktiveQualifikationen = mitarbeiter.Beschaeftigung[0].Verguetung.filter((qu) => qu.Verwenden);
	const standardQuali = aktiveQualifikationen.find((qu) => qu.IstStandardQualifikation);
	// Falls es nur eine Qualifikation gibt, nehmen wir automatisch diese an
	if (aktiveQualifikationen.length === 1) {
		schichtObjekt.QualifikationID = mitarbeiter.Beschaeftigung[0].Verguetung[0].QualifikationID;
		schichtObjekt.Qualifikation = findeQualifikation(qualifikationenU, schichtObjekt.QualifikationID).BezeichnungNeutral;
	} else if (standardQuali) {
		schichtObjekt.QualifikationID = standardQuali.QualifikationID;
		schichtObjekt.Qualifikation = findeQualifikation(qualifikationenU, standardQuali.QualifikationID).BezeichnungNeutral;
	} else {
		// Falls nicht müssten wir noch die Qualifikation abfragen...
		fuelleQualiDialogSelect(aktiveQualifikationen, qualifikationenU);
		const result = await SystemDialogService.instance.displayAsync('schicht-quali-dialog');
		if (!result.success) {
			return;
		}
		schichtObjekt.QualifikationID = result.data.QualifikationID;
		schichtObjekt.Qualifikation = result.data.BezeichnungNeutral;
	}
	let schichtNeu;
	// EGFZ Vorlagen haben eine rein numerische ID, echte Vorlagen eine ObjectId-Hexstring.
	// Nur bei reinem Nummern-String parseInt, sonst würde z.B. die ObjectId "6a3f..." fälschlich zu 6 (UnbezahltFrei).
	const egfzID = /^\d+$/.test(String(schichtVorlageID)) ? parseInt(schichtVorlageID, 10) : null;
	// Falls es keine EGFZ Schicht ist, dann laden wir ganz normal die Daten in die Vorlage.
	if (egfzID === null || !_.values(Egfz).includes(egfzID)) {
		schichtNeu = await schichtenService.erstelleSchichtObjektAusVorlage(schichtVorlageID, schichtObjekt);
	} else {
		// Falls es sich um eine EGFZ Schicht handelt, gibt es eine andere Funktion...
		schichtNeu = await schichtenService.erstelleEGFZSchicht(schichtObjekt, egfzID);
	}
	if (_.isEmpty(schichtNeu)) {
		return;
	}
	zeigeKleineNachricht('Schicht wurde erfolgreich erstellt!', 1);
	await zeigeNeueSchicht(schichtNeu, gridId);
}

function confirmQualiSelectDialog() {
	const dialogSelect = document.getElementById('schicht-quali-dialog-select');
	SystemDialogService.instance.confirm({
		QualifikationID: dialogSelect.value,
		BezeichnungNeutral: dialogSelect.options[dialogSelect.selectedIndex].innerText,
	});
}

/**
 * Befüllt das Dialog Schicht Quali Select Element für die Abfrage der gewünschten Qualifikation.
 * @param {array<object>} aktiveQualifikationen aktive Qualifikationen des Mitarbeiters
 * @param {array<object>} qualifikationen qualifikationen des Unternehmens
 */
function fuelleQualiDialogSelect(aktiveQualifikationen, qualifikationen) {
	const dialogSelect = document.getElementById('schicht-quali-dialog-select');
	dialogSelect.innerHTML = '';
	aktiveQualifikationen.forEach((quali) => {
		const newOption = document.createElement('option');
		newOption.setAttribute('value', quali.QualifikationID);
		newOption.innerText = findeQualifikation(qualifikationen, quali.QualifikationID).BezeichnungNeutral;
		dialogSelect.appendChild(newOption);
	});
}

/**
 * Markiert die übergebene Schicht als Kopierquelle. Erneutes Markieren der gleichen
 * Schicht hebt die Markierung wieder auf.
 * @param {string} schichtID
 * @param {HTMLElement} schichtElement
 */
function markiereKopierQuelle(schichtID, schichtElement) {
	// Bestehende Markierung im DOM entfernen, damit immer nur eine Quelle aktiv ist.
	document.querySelectorAll('.schicht-kopier-quelle').forEach((el) => el.classList.remove('schicht-kopier-quelle'));
	// Toggle: erneuter Klick auf die bereits markierte Schicht hebt die Markierung auf.
	if (kopierQuelleSchichtID === schichtID) {
		kopierQuelleSchichtID = null;
		setKopierQuellePreview(null);
		zeigeKleineNachricht('Kopierauswahl aufgehoben.', 0);
		return;
	}
	if (!schichtElement) {
		schichtElement = document.querySelector(`.schicht-div[aria-label="${schichtID}"]`);
	}
	if (!schichtElement) return;
	schichtElement.classList.add('schicht-kopier-quelle');
	kopierQuelleSchichtID = schichtID;
	setKopierQuellePreview(schichtElement);
	zeigeKleineNachricht('Schicht zum Kopieren markiert.\nKlicke auf das + einer Zelle, um sie einzufügen.', 1);
}

function clearKopierQuelle() {
	if (!kopierQuelleSchichtID) return;
	document.querySelectorAll('.schicht-kopier-quelle').forEach((el) => el.classList.remove('schicht-kopier-quelle'));
	kopierQuelleSchichtID = null;
	setKopierQuellePreview(null);
}

/**
 * Spiegelt die markierte Schicht in der Sidebar (über den Schichtvorlagen).
 * @param {HTMLElement|null} schichtElement
 */
function setKopierQuellePreview(schichtElement) {
	const wrapper = document.getElementById('kopier-quelle-anzeige');
	const preview = document.getElementById('kopier-quelle-preview');
	if (!wrapper || !preview) return;
	preview.innerHTML = '';
	if (!schichtElement) {
		wrapper.hidden = true;
		return;
	}
	const clone = schichtElement.cloneNode(true);
	clone.removeAttribute('onclick');
	clone.querySelectorAll('[onclick]').forEach((el) => el.removeAttribute('onclick'));
	// In der Vorschau zeigen wir nur den mittleren Teil – Freigabestatus + Span-Tools wegblenden.
	clone.querySelectorAll('[schicht-freigabe-status]').forEach((el) => el.remove());
	// Statt der Edit/Remove Tools setzen wir in die rechte span-div einen X Button im gleichen Stil.
	const spanDiv = clone.querySelector('[span-div]');
	if (spanDiv) {
		spanDiv.innerHTML = '<span id="kopier-quelle-clear" class="span-tools" title="Auswahl aufheben"><i class="bi bi-x-lg"></i></span>';
		spanDiv.querySelector('#kopier-quelle-clear').addEventListener('click', (event) => {
			event.stopPropagation();
			clearKopierQuelle();
		});
	}
	clone.classList.add('schicht-kopier-quelle');
	clone.classList.add('kopier-quelle-vorschau');
	clone.title = 'Aktuelle Kopierquelle';
	preview.appendChild(clone);
	wrapper.hidden = false;
}

/**
 * Kopiert die aktuell markierte Schicht in die Zielzelle. Löst Qualifikation und Posten
 * der Zielzelle auf und schickt sie an den Server.
 * @param {string} gridId tagZahl:postenID:mitarbeiterID
 */
async function kopiereSchichtInZelle(gridId) {
	if (!kopierQuelleSchichtID || kopierInProgress) return;
	kopierInProgress = true;
	try {
		const sourceID = kopierQuelleSchichtID;
		const parts = gridId.split(':');
		const heutigerWochentag = parseInt(parts[0], 10);
		const postenID = parts[1];
		const mitarbeiterID = parts[2];
		const neuesDatum = datumService.laufendesDatum.add(heutigerWochentag - 1, 'days');

		const mitarbeiterListe = await stammdatenService.getMitarbeiter();
		const mitarbeiter = findeMitarbeiter(mitarbeiterListe, mitarbeiterID);
		if (_.isEmpty(mitarbeiter)) {
			zeigeKleineNachricht('Mitarbeiter nicht gefunden!', -1);
			return;
		}
		const postenListe = await stammdatenService.getPosten();
		const posten = findePosten(postenListe, postenID);
		if (_.isEmpty(posten)) {
			zeigeKleineNachricht('Posten nicht gefunden!', -1);
			return;
		}
		const qualifikationenU = await stammdatenService.getQualifikationen();
		const aktiveQualifikationen = mitarbeiter.Beschaeftigung[0].Verguetung.filter((qu) => qu.Verwenden);
		const standardQuali = aktiveQualifikationen.find((qu) => qu.IstStandardQualifikation);

		const bereichSelect = document.getElementById('bereich-select');
		const schichtInfo = {
			MitarbeiterID: mitarbeiterID,
			PostenID: postenID,
			BereichID: posten.BereichID,
			Posten: posten.Posten,
			Bereich: bereichSelect?.selectedOptions[0]?.innerText || '',
			// Tageswechsel/Zeitzonen-sicher: nur das Datum als YYYY-MM-DD übertragen,
			// alle Uhrzeiten werden serverseitig aus der Quellschicht abgeleitet.
			Datum: neuesDatum.format('YYYY-MM-DD'),
			BetriebsstaetteID: stammdatenService.aktuelleBetriebsstaette,
		};
		if (aktiveQualifikationen.length === 1) {
			schichtInfo.QualifikationID = aktiveQualifikationen[0].QualifikationID;
			schichtInfo.Qualifikation = findeQualifikation(qualifikationenU, schichtInfo.QualifikationID).BezeichnungNeutral;
		} else if (standardQuali) {
			schichtInfo.QualifikationID = standardQuali.QualifikationID;
			schichtInfo.Qualifikation = findeQualifikation(qualifikationenU, standardQuali.QualifikationID).BezeichnungNeutral;
		} else {
			fuelleQualiDialogSelect(aktiveQualifikationen, qualifikationenU);
			const result = await SystemDialogService.instance.displayAsync('schicht-quali-dialog');
			if (!result.success) {
				return;
			}
			schichtInfo.QualifikationID = result.data.QualifikationID;
			schichtInfo.Qualifikation = result.data.BezeichnungNeutral;
		}
		const neueSchicht = await schichtenService.kopiereSchicht(sourceID, schichtInfo);
		if (!neueSchicht) {
			return;
		}
		zeigeKleineNachricht('Schicht wurde erfolgreich kopiert!', 1);
		await zeigeNeueSchicht(neueSchicht, gridId);
	} finally {
		kopierInProgress = false;
	}
}

/**
 * Initialisiert die globalen Click Listener für den Schicht-Kopieren-Modus.
 * Das Einfügen passiert ausschließlich über das + Symbol einer Zelle (via schichtAdden).
 * Diese Listener dienen nur dem Aufheben der Markierung bei Klicks außerhalb.
 */
function setupKopierClickHandler() {
	const previewWrapper = document.getElementById('kopier-quelle-anzeige');
	if (previewWrapper) {
		// Klicks innerhalb der Vorschau sollen nicht von dem globalen Listener als
		// "Klick außerhalb des Grids" interpretiert werden und die Auswahl aufheben.
		previewWrapper.addEventListener('click', (event) => event.stopPropagation());
	}
	const gridContent = document.getElementById('grid-content');
	if (gridContent) {
		gridContent.addEventListener('click', (event) => {
			if (!kopierQuelleSchichtID) return;
			// EGFZ-/Panel-Schichten haben keinen eigenen Klick-Handler – hier Auswahl aufheben.
			const schichtDiv = event.target.closest('.schicht-div');
			if (schichtDiv && (schichtDiv.classList.contains('egfz-schicht') || schichtDiv.classList.contains('schicht-panel'))) {
				clearKopierQuelle();
			}
		});
	}
	// Klick außerhalb von grid-content hebt die Markierung auf (Sidebar/Hintergrund...).
	// Ausgenommen sind das Grid selbst, die Kopierquelle-Vorschau, offene System-Dialoge
	// (z.B. die Qualifikationsabfrage beim Kopiervorgang) und die Grid-Toolbar
	// (Wochen-/Bereich-/Sortier-Navigation darf die Markierung nicht aufheben).
	// Capture-Phase, weil der confirm() Handler des Dialogs den Dialog-Inhalt aus #app-dialog
	// herausverschiebt — im Bubble-Phase wäre der Closest-Check schon fehlerhaft.
	document.addEventListener('click', (event) => {
		if (!kopierQuelleSchichtID) return;
		if (event.target.closest('#grid-content')) return;
		if (event.target.closest('.toolbar')) return;
		if (event.target.closest('#kopier-quelle-anzeige')) return;
		if (event.target.closest('#app-dialog')) return;
		clearKopierQuelle();
	}, true);
}

document.addEventListener('DOMContentLoaded', () => setupKopierClickHandler());

function togglePosten(thisElement) {
	const postenID = thisElement.id.split('-')[0];
	const postenItems = [...document.body.querySelectorAll(`[aria-level="${postenID}"]`)];
	postenItems.forEach((item) => item.classList.toggle('hidden'));
	thisElement.classList.toggle('area-header-closed');
}